import React, {FunctionComponent, useEffect, useState} from 'react';
import {FormAccessor} from 'b302-frontend-library';

import HanInput from '../../../utils/HanInput';
import Slider, {SliderChangedEvent} from '../../../layout/Slider';

interface SliderForm {
    minCosts: string;
    maxCosts: string;
}

interface Props {
    form: FormAccessor<SliderForm>;
    onInputChange: (e: any) => void;
    onChange: (e: SliderChangedEvent) => void;
    min: number;
    max: number;
}

const UniversityFilterSlider: FunctionComponent<Props> = (props) => {

    const [start, setStart] = useState<number>(props.min);
    const [end, setEnd] = useState<number>(props.max);

    useEffect(() => {
        setStart(props.form.values.minCosts);
        setEnd(props.form.values.maxCosts);
    },[props.form.values.minCosts, props.form.values.maxCosts]);

    const onChange = (e: SliderChangedEvent) => {
        const [start, end] = e.values;

        setStart(start);
        setEnd(end);
    };

    return (
        <div>
            <div className={'university-filter__center-space'}>
                <HanInput
                    form={props.form}
                    onChange={props.onInputChange}
                    className={'university-filter__input'}
                    id={'minCosts'}/>

                <HanInput
                    id={'maxCosts'}
                    form={props.form}
                    onChange={props.onInputChange}
                    className={'university-filter__input'}
                />
            </div>

            <div className={'university-filter__slider-container'}>
                <Slider
                    min={props.min}
                    max={props.max}
                    value={[start, end]}
                    onChange={onChange}
                    onAfterChange={props.onChange}
                    pearling={true}
                    ids={['minCosts', 'maxCosts']}/>
            </div>
        </div>
    );
};

export default UniversityFilterSlider;
